<template>
  <div class="row before-document-create">
    <div class="col-12">
      <span v-html="schema.confirmed.$title" />
    </div>
  </div>
</template>

<script>
// @vuese
// Komponent dla listy BiK
// @group ActionData
export default {
  props: {
    schema: { type: Object, required: false }
  }
};
</script>

<style>
.before-document-create a {
  text-decoration: underline !important;
}
</style>
